<template>
    <div v-if="!isLoading" class="family-search-header-title pa-text-[16px] pa-h-6 pa-leading-6 pa-overflow-hidden pa-font-semibold">
        <ElPopover
            popper-class="family-search-header-title__popover"
            placement="top-start"
            trigger="hover"
            :visible-arrow="false"
            :open-delay="POPPER_OPEN_DELAY"
        >
            <template #reference>
                <p class="pa-whitespace-nowrap pa-overflow-hidden pa-overflow-ellipsis" v-html="title" />
            </template>
            <p class="pa-text-black pa-max-w-[400px] pa-break-words" v-html="title" />
        </ElPopover>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Popover } from 'element-ui';
import { POPPER_OPEN_DELAY } from '@/constants';
import { useFamilySearchPatentInfo } from '@/composables/use-family-search-patent-info';
import { useI18n } from '@/composables/use-i18n';

const ElPopover = Popover;
const { patentInfo, isLoading } = useFamilySearchPatentInfo();
const { t } = useI18n();

const title = computed(() => `${patentInfo.value.translation ? `[${t('translateTitle')}]` : ''} ${patentInfo.value.title || ''}`);
</script>

<style lang="scss">

</style>
